import { styled } from '@zenbusiness/zui/styles';

export const AccountWrapperStyle = ({ theme }) => ({
  width: '100%',
  height: 'auto',
  padding: '25px 0',
  display: 'flex',
  borderBottom: '1px solid',
  borderColor: theme.palette.border.main,
  justifyContent: 'space-between',
  alignItems: 'center'
});

export const AccountWrapper = styled('div')(AccountWrapperStyle);
